var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.941,
    height: 15.941,
    viewBox: "0 0 15.941 15.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.764,0H1.178A1.16,1.16,0,0,0,0,1.142V14.8a1.161,1.161,0,0,0,1.178,1.143H14.764A1.16,1.16,0,0,0,15.941,14.8V1.142A1.16,1.16,0,0,0,14.764,0ZM4.833,13.344H2.424v-7.2H4.833v7.2Zm-1.2-8.181H3.613a1.247,1.247,0,1,1,.031-2.487,1.248,1.248,0,1,1-.015,2.487Zm9.886,8.181H11.107V9.493c0-.968-.349-1.628-1.22-1.628a1.315,1.315,0,0,0-1.235.875,1.607,1.607,0,0,0-.08.583v4.02H6.165s.032-6.522,0-7.2H8.572v1.02a2.391,2.391,0,0,1,2.17-1.19c1.585,0,2.773,1.028,2.773,3.24v4.127ZM8.557,7.19l.016-.023V7.19Z",
    transform: "translate(0)",
    fill: "#4b4aee"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d84c4341.svg";
export { ForwardRef as ReactComponent };